import { render } from "./TypeSelect.vue?vue&type=template&id=fe3f3b94&bindings={}"
import script from "./TypeSelect.vue?vue&type=script&lang=ts"
export * from "./TypeSelect.vue?vue&type=script&lang=ts"

import "./TypeSelect.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script